import { render, staticRenderFns } from "./index.vue?vue&type=template&id=147fc472"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147fc472')) {
      api.createRecord('147fc472', component.options)
    } else {
      api.reload('147fc472', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=147fc472", function () {
      api.rerender('147fc472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tinymce/index.vue"
export default component.exports